/*******************************************************************************
 * getShortcutModifiers */
/**
 * Returns an object that checks the attributes for known shortcut modifiers.
 *******************************************************************************/
/* @ngInject */ function getShortcutModifiers($element, SHORTCUT_CONSTANTS) {
  return function () {
    return {
      modAlt: $element[0].hasAttribute(SHORTCUT_CONSTANTS.MODIFIER_ALT.attr),
      modCtrl: $element[0].hasAttribute(SHORTCUT_CONSTANTS.MODIFIER_CTRL.attr),
      modShift: $element[0].hasAttribute(SHORTCUT_CONSTANTS.MODIFIER_SHIFT.attr)
    };
  };
}

/*******************************************************************************
 * isDisabled */
/**
 * Checks the current enabled status for the shortcut.
 *******************************************************************************/
/* @ngInject */ function isDisabled($element, SHORTCUT_CONSTANTS) {
  return function () {
    return (
      $element[0].hasAttribute(SHORTCUT_CONSTANTS.ATTR_DISABLED) &&
      $element[0].getAttribute(SHORTCUT_CONSTANTS.ATTR_DISABLED) === 'true'
    );
  };
}

/*******************************************************************************
 * sentryComponentReporter */
/**
 * Alerts the user to an unknown error, then rethrows it with the component state
 * attached so Sentry can report it.
 *
 * @param  error  The error to report.
 * @param  extraPropertiesToReport  Extra properties to attach to the
 *     Sentry report.
 *******************************************************************************/
/* @ngInject */ function sentryComponentReporter($ctrl, Alert) {
  return function (error, extraPropertiesToReport) {
    Alert.error(
      'An unknown error occurred. Please refresh the page and try again.'
    );

    const state = {
      expectedModifiers: {
        alt: $ctrl.modAlt,
        ctrl: $ctrl.modCtrl,
        shift: $ctrl.modShift
      },
      expectedKey: $ctrl.getTargetKey()
    };

    const reportState = Object.assign(state, extraPropertiesToReport || {});

    throw Object.assign(error, { reportState });
  };
}

/*******************************************************************************
 * shortcutLabel */
/**
 * Returns a text representation of the shortcut.
 *******************************************************************************/
/* @ngInject */ function shortcutLabel($ctrl, SHORTCUT_CONSTANTS) {
  return function () {
    const keyModifiers = [];

    /*----------------------------------------------------------------*/
    /* On a Mac, "Option" is the equivalent key for "Alt" on Windows. */
    /*----------------------------------------------------------------*/
    if ($ctrl.modAlt) {
      keyModifiers.push(
        SHORTCUT_CONSTANTS.IS_MAC
          ? SHORTCUT_CONSTANTS.MODIFIER_OPT.name
          : SHORTCUT_CONSTANTS.MODIFIER_ALT.name
      );
    }

    if ($ctrl.modCtrl) keyModifiers.push(SHORTCUT_CONSTANTS.MODIFIER_CTRL.name);
    if ($ctrl.modShift)
      keyModifiers.push(SHORTCUT_CONSTANTS.MODIFIER_SHIFT.name);
    keyModifiers.push($ctrl.getTargetKey());

    return `(${keyModifiers.join(' + ')})`;
  };
}

export {
  getShortcutModifiers,
  isDisabled,
  sentryComponentReporter,
  shortcutLabel
};
